/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttachProcessOfferToEmailRequestDto } from '../models';
// @ts-ignore
import type { AttachProcessOfferToEmailResponseContentDto } from '../models';
// @ts-ignore
import type { ProcessOfferAttachedEmailDto } from '../models';
/**
 * RestProcessOfferEmailAttachmentApi - axios parameter creator
 */
export const RestProcessOfferEmailAttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate offer PDF and attach to draft email (idempotent per offer+email)
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} emailId 
         * @param {AttachProcessOfferToEmailRequestDto} attachProcessOfferToEmailRequestDto Pick which PDF variant to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachProcessOfferToEmail: async (userId: string, processId: string, processOfferId: string, emailId: string, attachProcessOfferToEmailRequestDto: AttachProcessOfferToEmailRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('attachProcessOfferToEmail', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('attachProcessOfferToEmail', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('attachProcessOfferToEmail', 'processOfferId', processOfferId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('attachProcessOfferToEmail', 'emailId', emailId)
            // verify required parameter 'attachProcessOfferToEmailRequestDto' is not null or undefined
            assertParamExists('attachProcessOfferToEmail', 'attachProcessOfferToEmailRequestDto', attachProcessOfferToEmailRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/emails/{emailId}/attach`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachProcessOfferToEmailRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List emails the offer has been attached to
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferEmails: async (userId: string, processId: string, processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOfferEmails', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferEmails', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOfferEmails', 'processOfferId', processOfferId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/emails`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessOfferEmailAttachmentApi - functional programming interface
 */
export const RestProcessOfferEmailAttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessOfferEmailAttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate offer PDF and attach to draft email (idempotent per offer+email)
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} emailId 
         * @param {AttachProcessOfferToEmailRequestDto} attachProcessOfferToEmailRequestDto Pick which PDF variant to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachProcessOfferToEmail(userId: string, processId: string, processOfferId: string, emailId: string, attachProcessOfferToEmailRequestDto: AttachProcessOfferToEmailRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachProcessOfferToEmailResponseContentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachProcessOfferToEmail(userId, processId, processOfferId, emailId, attachProcessOfferToEmailRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferEmailAttachmentApi.attachProcessOfferToEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List emails the offer has been attached to
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferEmails(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessOfferAttachedEmailDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferEmails(userId, processId, processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferEmailAttachmentApi.getProcessOfferEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessOfferEmailAttachmentApi - factory interface
 */
export const RestProcessOfferEmailAttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessOfferEmailAttachmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate offer PDF and attach to draft email (idempotent per offer+email)
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {string} emailId 
         * @param {AttachProcessOfferToEmailRequestDto} attachProcessOfferToEmailRequestDto Pick which PDF variant to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachProcessOfferToEmail(userId: string, processId: string, processOfferId: string, emailId: string, attachProcessOfferToEmailRequestDto: AttachProcessOfferToEmailRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AttachProcessOfferToEmailResponseContentDto> {
            return localVarFp.attachProcessOfferToEmail(userId, processId, processOfferId, emailId, attachProcessOfferToEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List emails the offer has been attached to
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferEmails(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferAttachedEmailDto>> {
            return localVarFp.getProcessOfferEmails(userId, processId, processOfferId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessOfferEmailAttachmentApi - interface
 */
export interface RestProcessOfferEmailAttachmentApiInterface {
    /**
     * 
     * @summary Generate offer PDF and attach to draft email (idempotent per offer+email)
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} emailId 
     * @param {AttachProcessOfferToEmailRequestDto} attachProcessOfferToEmailRequestDto Pick which PDF variant to attach
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attachProcessOfferToEmail(userId: string, processId: string, processOfferId: string, emailId: string, attachProcessOfferToEmailRequestDto: AttachProcessOfferToEmailRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AttachProcessOfferToEmailResponseContentDto>;

    /**
     * 
     * @summary List emails the offer has been attached to
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferEmails(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessOfferAttachedEmailDto>>;

}

/**
 * RestProcessOfferEmailAttachmentApi - object-oriented interface
 */
export class RestProcessOfferEmailAttachmentApi extends BaseAPI implements RestProcessOfferEmailAttachmentApiInterface {
    /**
     * 
     * @summary Generate offer PDF and attach to draft email (idempotent per offer+email)
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {string} emailId 
     * @param {AttachProcessOfferToEmailRequestDto} attachProcessOfferToEmailRequestDto Pick which PDF variant to attach
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public attachProcessOfferToEmail(userId: string, processId: string, processOfferId: string, emailId: string, attachProcessOfferToEmailRequestDto: AttachProcessOfferToEmailRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferEmailAttachmentApiFp(this.configuration).attachProcessOfferToEmail(userId, processId, processOfferId, emailId, attachProcessOfferToEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List emails the offer has been attached to
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferEmails(userId: string, processId: string, processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestProcessOfferEmailAttachmentApiFp(this.configuration).getProcessOfferEmails(userId, processId, processOfferId, options).then((request) => request(this.axios, this.basePath));
    }
}

